<template>
  <div class="reset container">
    <v-card id="login-card">
      <img id="logo" src="../assets/img/ft-logo.png"></img><br>
      <input type="text" v-model="email" placeholder="Email"><br>
      <v-btn v-on:click="resetPassword" class="gray" id="signin-btn">Reset password</v-btn>
      <p><router-link to="/login">Sign in</router-link></p>
    </v-card>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import {store} from '../store/store.js'
  import Vuex from 'vuex'

  export default {
    name: 'login',
    data: function() {
      return {
        email: ''
      }
    },
    store: store,
    methods: {
      resetPassword: function() {
        firebase.auth().sendPasswordResetEmail(this.email).then(function() {
          // Email sent.
        }).catch(function(error) {
          // An error happened.
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .reset {
    max-width: 450px !important;
  }
  #login-card {
    padding: 40px;
  }
  input {
    margin: 10px 0;
    width: 100%;
    padding: 15px;
    border: 0;
    background-color: #f2f2f2;
    color: #000;
    font-weight: bold;
  }
  button {
    height: 50px;
    margin: 0 auto;
    margin-top: 20px;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
  button#signin-btn {
    font-size: 1em;
    border-radius: 35px;
  }
  @media (max-width: 769px) {
    .reset {
      margin-top: 35%;
    }
    button {
      height: 40px;
    }
    button#signin-btn {
      font-size: 1em;
      padding-top: 8px;
    }
  }
</style>
